var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVerticalDashedLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2,
    height: 137,
    viewBox: "0 0 2 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1C1 69.9465 1 67.0535 1 136",
    stroke: "#C1BFBF",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "5 7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDashedLine);
export default __webpack_public_path__ + "static/media/vertical-dashed-line.c2e0416e1e012a63063b8a2c2d51aeba.svg";
export { ForwardRef as ReactComponent };